import { call, put, select } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { OK } from '../../../configs/serverStatusCodes';
import { getLocale, getRefreshToken, getToken } from '../../../utils/redux';
import { shouldRefreshToken } from '../../../utils/authToken';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import {
  authorizedLogoutSuccessful,
  authorizedRefreshFailed,
  authorizedRefreshSuccessful,
} from '../actions';

const TOKEN_REFRESH_SKEW_SECONDS = Number(process.env.REACT_APP_TOKEN_REFRESH_SKEW_SECONDS || 90);

export const requestTokenRefresh = (token, locale, refreshToken = null) => fetch(`${BACKEND_URL}/auth/refresh`, {
  method: 'POST',
  cache: 'no-cache',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': locale,
    Authorization: `Bearer ${token}`,
  },
  ...(refreshToken ? { body: JSON.stringify({ refresh: refreshToken }) } : {}),
});

export default function* authorizedRefresh(action) {
  const token = yield select(getToken);
  const refreshToken = yield select(getRefreshToken);
  const locale = yield select(getLocale);

  if (!token || !shouldRefreshToken(token, TOKEN_REFRESH_SKEW_SECONDS)) {
    yield call(resolveActionPromise(action, token));
    return;
  }

  try {
    const response = yield call(requestTokenRefresh, token, locale, refreshToken);
    const body = yield response.json();

    if (response.status === OK && body?.data?.access) {
      yield put(authorizedRefreshSuccessful(body.data));
      yield call(resolveActionPromise(action, body.data.access));
      return;
    }

    yield put(authorizedRefreshFailed());
    yield put(authorizedLogoutSuccessful());
    yield call(rejectActionPromise(action, body));
  } catch (e) {
    yield put(authorizedRefreshFailed());
    yield call(rejectActionPromise(action, e));
  }
}
